//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import edit_input from "@/components/input_item";
import PageBtns from '@/components/common_pageBtns.vue'
export default {
  components: { edit_input, PageBtns },
  data() {
    return {
      nodeInfo: {},
      pageData: {},
      btnConfig: {
        list: [
          {text:'返回', type:'primary',action: () => this.$router.go(-1)}
        ],
      },
      mingxi_date:{
        top:{
          num:"",
          type:"",
        },
        _first:{
          dongzuo:"",
          danhao:"",
          time:"",
          quxian:"",
          jifen_num:"",
          jifen_yuan:"",
        },
        _two:{
          name:"",
          jiaose:"",
          tel:"",
        },
        _three:{
          type:"",
          jifen:"",
          yue:"",
          beizhu:""
        }
      },
      edit_input: [
        { v: "操作", value: "", no_arrow: true, read: true },
        { v: "操作单号", value: "", no_arrow: true, read: true },
        { v: "操作时间", value: "", no_arrow: true, read: true },
      ],
      edit_input1: [
        { v: "节点名称", value: "", no_arrow: true, read: true },
        { v: "操作人", value: "", no_arrow: true, read: true, hide_border: true },
      ],
      edit_input2: [
        { v: "本次操作", value: "", no_arrow: true, read: true },
        { v: "账户结余", value: "", no_arrow: true, read: true, hide_border: true },
      ],
    };
  },

  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },

  async created () {
    if (Object.keys(this.userInfo).length == 0) {
      await this.getMemberInfo()
    }
    this.getPageData()
    this.getPassageNodeInfo()
  },

  methods: {
    getPassageNodeInfo() {
      this.$http({
        url: this.$api.GetPassageNodeInfo,
        method:"Post"
      }).then(res=>{
        if(res.data.state==1){
          this.$msg.hideLoading ()
          this.nodeInfo=res.data.data;
        }   
      })
    },

    getPageData () {
      this.$msg.loading()
      this.$http({
        url: this.$api.GetPassageNodeCashDataLogInfo + `?openId=` + this.$route.query.openId
        // url: this.$api.GetPassageNodeCashDataLogInfo + `?openId=36ecf8b0fd3041da84bc54e166b4d6b1`
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.pageData = res.data.data
          this.setPageData()
        }
      })
    },
    setPageData () {
      this.edit_input[0].value = this.pageData.ActionType
      this.edit_input[1].value = this.pageData.OrderNo
      this.edit_input[2].value = this.pageData.UpdateOn
      this.edit_input1[0].value = this.nodeInfo.name
      this.edit_input1[1].value = this.userInfo.FansNickName
      if (this.pageData.ActionType && this.pageData.ActionType == '收入') {
        this.edit_input2[0].value = '+' + this.pageData.ThisMoney
      } else if (this.pageData.ActionType && this.pageData.ActionType == '支出') {
        this.edit_input1[2].v = '操作人编码'
        this.edit_input1[2].value = this.userInfo.UserSystemCode
        this.edit_input2[0].value = '-' + this.pageData.ThisMoney
      }
      this.edit_input2[1].value = this.pageData.Money
    },

    async getMemberInfo (fansOpenId, bdOpenId) {
      let {data} = await this.$http({
        url: this.$api.GetMemberInfo,
        method: 'post'
      })
      if(data.state==1) {
        this.$store.commit('set_userInfo', data.data)
      }
    },
    
    go_back() {
     this.$router.go(-1)
    },
    go_page(url) {
      if (url) {
        wx.navigateTo({
          url: url
        });
      }
    },
  },

};
